import { z } from 'zod'

export const normalizeSearchRuleQuery = (value: string) => value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('de')
const term = z.string().trim().min(2).max(160)
// Kept only for old cached admin clients. A shop never scopes a saved rule now.
export const searchRuleScopeSchema = z.object({ shopId: z.number().int().positive().optional() }).strict()
const ruleFields = {
  query: term, replacement: term,
  hint: z.string().trim().max(300).default(''), enabled: z.boolean(),
}
export const searchRuleSchema = z.object({
  shopId: z.number().int().positive().optional(), ...ruleFields,
}).strict().refine(rule => normalizeSearchRuleQuery(rule.query) !== normalizeSearchRuleQuery(rule.replacement), 'Suchbegriff und Ersatzbegriff müssen verschieden sein.')
export type SearchRule = z.infer<typeof searchRuleSchema>
export const searchRuleConflictSchema = z.object({
  query: term,
  variants: z.array(z.object({ shopId: z.number().int().positive(), ...ruleFields })).min(2),
})
export const searchRulesResponseSchema = z.object({ rules: z.array(searchRuleSchema), conflicts: z.array(searchRuleConflictSchema).default([]) })
export type SearchRulesResponse = z.infer<typeof searchRulesResponseSchema>
export const searchAdjustmentSchema = z.object({ original: z.string(), replacement: z.string(), hint: z.string() })
export type SearchAdjustment = z.infer<typeof searchAdjustmentSchema>
